module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "chord-selector"
  }, [_c('legend', [_vm._v("Chord Selector")]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Base")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    attrs: {
      "id": "chord-selector-key"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.playChord]
    }
  }, _vm._l((_vm.keys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.value
      }
    }, [_vm._v(_vm._s(key.name))])
  }), 0)]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Flavour")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flavour),
      expression: "flavour"
    }],
    attrs: {
      "id": "chord-selector-flavour"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.flavour = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.playChord]
    }
  }, _vm._l((_vm.flavours), function(flavour) {
    return _c('option', {
      domProps: {
        "value": flavour.value
      }
    }, [_vm._v(_vm._s(flavour.name))])
  }), 0)]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stepThrough),
      expression: "stepThrough"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.stepThrough) ? _vm._i(_vm.stepThrough, null) > -1 : (_vm.stepThrough)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.stepThrough,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.stepThrough = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.stepThrough = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.stepThrough = $$c
        }
      }, _vm.playChord]
    }
  }), _vm._v(" "), _c('span', [_vm._v("Step through chord")])]), _vm._v(" "), (_vm.canClearSelection) ? _c('button', {
    on: {
      "click": _vm.clearChordSelect
    }
  }, [_vm._v("Clear")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bbab540!./src/components/chord-selector/chord-selector.html
// module id = 112
// module chunks = 2